import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsBar = ({ totalClients, activeClients, pendingClients, lastSync }) => {
  const stats = [
    {
      icon: 'Users',
      label: 'Gesamt Klienten',
      value: totalClients?.toLocaleString('de-DE'),
      color: 'text-primary'
    },
    {
      icon: 'UserCheck',
      label: 'Aktive Klienten',
      value: activeClients?.toLocaleString('de-DE'),
      color: 'text-success'
    },
    {
      icon: 'Clock',
      label: 'Ausstehend',
      value: pendingClients?.toLocaleString('de-DE'),
      color: 'text-warning'
    },
    {
      icon: 'RefreshCw',
      label: 'Letzte Synchronisation',
      value: lastSync,
      color: 'text-muted-foreground'
    }
  ];

  return (
    <div className="bg-card border-b border-border p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {stats?.map((stat, index) => (
          <div key={index} className="flex items-center gap-3 p-3 bg-muted/30 rounded-lg">
            <div className={`p-2 rounded-lg bg-background ${stat?.color}`}>
              <Icon name={stat?.icon} size={20} />
            </div>
            <div>
              <p className="text-xs text-muted-foreground">{stat?.label}</p>
              <p className="text-lg font-semibold text-foreground">{stat?.value}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsBar;